import React from 'react';
import styles from './DescriptionForm.module.css';

function DescriptionForm({ formData, handleInputChange }) {
    return (
        <div className={styles.descriptionSection}>
            <input
                type="text"
                name="guitarName"
                placeholder="기타 이름을 입력해주세요."
                value={formData.guitarName}
                onChange={handleInputChange}
                className={styles.descriptionInput}
            />

            <input
                type="text"
                name="usagePeriod"
                placeholder="사용 기간을 입력해주세요. (예: 2년)"
                value={formData.usagePeriod}
                onChange={handleInputChange}
                className={styles.descriptionInput}
            />

            <input
                type="number"
                name="price"
                placeholder="판매 가격을 입력해주세요. (예: 500000)"
                value={formData.price}
                onChange={handleInputChange}
                className={styles.descriptionInput}
            />

            <textarea
                name="description"
                placeholder="기타에 대한 설명을 입력해주세요."
                value={formData.description}
                onChange={handleInputChange}
                className={styles.descriptionTextarea}
            />

            <textarea
                name="etc"
                placeholder="특이사항을 입력해주세요."
                value={formData.etc}
                onChange={handleInputChange}
                className={styles.descriptionTextarea}
            />
        </div>
    );
}

export default DescriptionForm;
